import React, { useEffect } from 'react';
import { SearchWrapper, Wrapper } from './filter-catalog-products.styles';
import { FilterCatalogProductsProps } from './types';
import { useProductTypesListSharedQuery } from '@entities/product/libs/hooks/use-product-types-list-shared-query/use-product-types-list-shared-query';
import { DEFAULT_PRODUCT_TYPES_LIST_PARAMETERS } from '@entities/product/config/store-constants';
import { MenuFilters } from './menu-filter/menu-filter';
import { Search } from '@shared/ui/search/search';

export const FilterCatalogProducts: React.FC<FilterCatalogProductsProps> = ({
    productsListParameters,
    sortParametersAfterClearSearch,
    setProductsListParameters,
}) => {
    const [getProductTypes] = useProductTypesListSharedQuery({ ...DEFAULT_PRODUCT_TYPES_LIST_PARAMETERS, take: null });

    useEffect(() => {
        getProductTypes({ ...DEFAULT_PRODUCT_TYPES_LIST_PARAMETERS, take: null });
    }, []);

    return (
        <Wrapper>
            <SearchWrapper>
                <Search
                    sortParametersAfterClearSearch={sortParametersAfterClearSearch}
                    parameters={productsListParameters}
                    setParameters={setProductsListParameters}
                />
            </SearchWrapper>
            <MenuFilters parameters={productsListParameters} setParameters={setProductsListParameters} />
        </Wrapper>
    );
};
